/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, EventEmitter, Input, Output, ChangeDetectionStrategy} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmModal} from './confirm-modal.model';
import {AlertNotificationSeverity} from '../../../alert-notification-severity.model';
import {ConfirmModalManualChecks} from './confirm-modal-manual-checks.model';
import {ConfirmModalCheck} from './confirm-modal-check.model';

@Component({
    selector: 'app-confirm-modal-old',
    templateUrl: './confirm-modal.component.html',
    styleUrls: ['./confirm-modal.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
/**
 * @deprecated <p><i>Deprecated</i>: use the other component with the same name.
 */
export class ConfirmModalComponent {

    @Input() titleText: string;
    @Input() subtitleText: string;
    @Input() footer?: string;
    @Input() details?: string[];
    @Input() alertNotificationSeverity: AlertNotificationSeverity;
    @Input() primaryButtonText: string;
    @Input() primaryButtonCustomizedClass: string;
    @Input() secondaryButtonText: string;
    @Input() manualChecks: ConfirmModalManualChecks;
    @Input() width: number;
    @Input() hasCloseButton = true;
    @Output() confirmEvent = new EventEmitter<any>();
    @Output() secondaryEvent = new EventEmitter<any>();
    private readonly defaultWidth = 460;

    constructor(public activeModal: NgbActiveModal) {
    }

    initModal(confirmModal: ConfirmModal): ConfirmModalComponent {
        this.titleText = confirmModal.titleText;
        this.subtitleText = confirmModal.subtitleText;
        this.footer = confirmModal.footer;
        this.details = confirmModal.details;
        this.alertNotificationSeverity = confirmModal.alertNotificationSeverity;
        this.primaryButtonText = confirmModal.primaryButtonText;
        this.primaryButtonCustomizedClass = confirmModal.primaryButtonCustomizedClass;
        this.secondaryButtonText = confirmModal.secondaryButtonText;
        this.manualChecks = confirmModal.manualChecks || new ConfirmModalManualChecks();
        this.width = confirmModal.width;
        this.hasCloseButton = confirmModal.hasCloseButton != null ? confirmModal.hasCloseButton : this.hasCloseButton;
        // FIXME: CTWILS-2360
        return this;
    }

    clickPrimaryButton(): void {
        this.confirmEvent.emit();
        this.activeModal.dismiss();
    }

    disablePrimaryButton(): boolean {
        return this.manualChecks.inputs.length > 0 ? !this.manualChecks.inputs.every(manualCheck => manualCheck.checked) : false;
    }

    clickSecondaryButton(): void {
        this.secondaryEvent.emit();
        this.activeModal.dismiss();
    }

    toggleManualCheck(manualCheck: ConfirmModalCheck): void {
        manualCheck.checked = !manualCheck.checked;
    }


    applyLabelClass(manualCheck: ConfirmModalCheck): string {
        return manualCheck.checked ? 'modal-manual-label modal-manual-label-checked' : 'modal-manual-label';
    }

    showManualInputs(): boolean {
        return this.manualChecks ? this.manualChecks.inputs.length > 0 : false;
    }

    getPrimaryButtonClass(): string {
        return this.primaryButtonCustomizedClass ? this.primaryButtonCustomizedClass : 'btn-primary';
    }

    isError(): boolean {
        return this.alertNotificationSeverity === AlertNotificationSeverity.ERROR;
    }

    isWarning(): boolean {
        return this.alertNotificationSeverity === AlertNotificationSeverity.WARNING;
    }

    isInfo(): boolean {
        return this.alertNotificationSeverity === AlertNotificationSeverity.INFORMATION;
    }

    setWidth(): number {
        return this.width ? this.width : this.defaultWidth;
    }

    hasDetails(): boolean {
        return this.details != null && this.details.length > 0;
    }

    hasFooter(): boolean {
        return this.footer != null;
    }
}
